import React, { FC } from "react";
import { Field } from "react-final-form";
import { makeStyles, Theme } from "@material-ui/core";
import Autocomplete from "../../../components/Autocomplete";
import { COURSE_HOUSING_TYPES, COURSE_TYPES } from "../constants";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    marginTop: theme.spacing(3),
  },
}));

const LanguageCoursesFilterForm: FC = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="courseType"
          label="Course Type"
          placeholder="Please Select"
          options={COURSE_TYPES}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="housingType"
          label="Housing Type"
          placeholder="Please Select"
          options={COURSE_HOUSING_TYPES}
          component={Autocomplete}
        />
      </div>
    </>
  );
};

export default React.memo(LanguageCoursesFilterForm);
